import type { BadgeVariations } from '@synqo/frontend-component-library';
import { EnumWorkflowRunStatus, EnumWorkflowStepOutcome } from './Generated';

export const getEnumWorkflowRunStatusLabel = (status: EnumWorkflowRunStatus): string => {
    switch (status) {
        case EnumWorkflowRunStatus.Running:
            return 'Läuft';
        case EnumWorkflowRunStatus.AwaitingInput:
            return 'Wartet auf Eingabe';
        case EnumWorkflowRunStatus.Succeeded:
            return 'Erfolgreich';
        case EnumWorkflowRunStatus.Failed:
            return 'Fehlgeschlagen';
        case EnumWorkflowRunStatus.Cancelled:
            return 'Abgebrochen';
        default:
            return 'Unbekannt';
    }
};

export const getBadgeVariantByWorkflowRunStatus = (status: EnumWorkflowRunStatus): BadgeVariations => {
    switch (status) {
        case EnumWorkflowRunStatus.Succeeded:
            return 'success';
        case EnumWorkflowRunStatus.AwaitingInput:
            return 'warning';
        case EnumWorkflowRunStatus.Failed:
            return 'danger';
        case EnumWorkflowRunStatus.Cancelled:
            return 'default';
        case EnumWorkflowRunStatus.Running:
        default:
            return 'default';
    }
};

export const getEnumWorkflowStepOutcomeLabel = (outcome: EnumWorkflowStepOutcome): string => {
    switch (outcome) {
        case EnumWorkflowStepOutcome.Succeeded:
            return 'Erfolgreich';
        case EnumWorkflowStepOutcome.Failed:
            return 'Fehlgeschlagen';
        case EnumWorkflowStepOutcome.Skipped:
            return 'Übersprungen';
        case EnumWorkflowStepOutcome.PausedForInput:
            return 'Wartet auf Eingabe';
        case EnumWorkflowStepOutcome.Running:
            return 'Läuft';
        default:
            return 'Unbekannt';
    }
};

export const getBadgeVariantByWorkflowStepOutcome = (outcome: EnumWorkflowStepOutcome): BadgeVariations => {
    switch (outcome) {
        case EnumWorkflowStepOutcome.Succeeded:
            return 'success';
        case EnumWorkflowStepOutcome.PausedForInput:
            return 'warning';
        case EnumWorkflowStepOutcome.Failed:
            return 'danger';
        case EnumWorkflowStepOutcome.Running:
        case EnumWorkflowStepOutcome.Skipped:
        default:
            return 'default';
    }
};
